import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../util/Rest';
const initialData = {
  clientData: [],
  rateHistory: [],
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'clientDashboard',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getClientData: (state, action) => {
      state.clientData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getRateHistory: (state, action) => {
      state.rateHistory = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    resetStatus: (state) => {
      state.communicationTimeLineStatus = null;
      state.errorMsg = null;
      state.successMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {getClientData, fetchStart, fetchError, resetStatus, getRateHistory} = slice.actions;

export const fetchClientData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`maintenance/get/all/client`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getClientData(data?.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : ''));
      });
  };
};

export const fetchClientDataNoload = (data) => {
  return (dispatch) => {
    httpPost(`maintenance/get/all/client`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getClientData(data?.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : ''));
      });
  };
};

export const fetchRateHistoryData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`client/search/subscribeHistory/all`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getRateHistory(data?.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : ''));
      });
  };
};

export const resetStatusCode = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
